import { render, staticRenderFns } from "./VerifyAcuApprovalTemplate.vue?vue&type=template&id=2ec77bc4&scoped=true"
import script from "./VerifyAcuApprovalTemplate.vue?vue&type=script&lang=js"
export * from "./VerifyAcuApprovalTemplate.vue?vue&type=script&lang=js"
import style0 from "./VerifyAcuApprovalTemplate.vue?vue&type=style&index=0&id=2ec77bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec77bc4",
  null
  
)

export default component.exports